import { render, staticRenderFns } from "./ConsultantRatingCard.vue?vue&type=template&id=5f12c7f1&"
import script from "./ConsultantRatingCard.vue?vue&type=script&lang=ts&"
export * from "./ConsultantRatingCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports